<div class="formwrap overflow-slider" id="panelList">
  <div class="Header">
    <p-tabView>
      <div class="second-fieldset sessionPanelList">
        <app-panel-list
          [panelList]="sessionAttendeePanelListData"
          [noResultFound] = "noData"
          (selectedItems)="getSelectedItems($event)"
          [ifAdditionalItems]="true"
        >
          <span class="additional-items">
            <p-checkbox
              class="col p-0 pr-2"
              name="Show All"
              value="all"
              *ngIf="isShowCheckbox === true"
              [(ngModel)]="selectCheckbox"
              [binary]="true"
              (onChange)="checkboxSelectionChange()"
            ></p-checkbox>
            <label>
              {{ checkboxLabel }}
            </label>
            <i
              *ngIf="showInformationIconCheckbox === true"
              class="fa fa-info-circle ml-2 info-icon-color"
              aria-hidden="true"
              pTooltip="{{ informationIconTooltip }}"
            ></i>
          </span>
          <ng-template
            #templateRef
            let-data="dataVar"
            *ngIf="sessionAttendeesData"
          >
            <div panel-content class="grid SessionAttendeePanelCards">
              <div class="col-1 w-13rem text-left sessionAttendeeColumn1">
                <app-label labelText="Attendee"></app-label>
                <div>
                  <app-read-only [ngClass]="{'inActiveGroup': data?.isAttendeeTerminated === true}"
                    readonlyText="{{ data?.attendee }}"
                    toolTipMessage="{{ data?.attendee }}"
                  ></app-read-only>
                </div>
              </div>
              <div class="col-2 w-13rem text-left sessionAttendeeColumn2">
                <app-label labelText="Participation"></app-label>
                <div class="grid pt-1 participation-status">
                  <div class="col max-w-0 pb-0">
                    <em
                      class="pi pi-circle-fill ml-1 mr-1 mt-1"
                      [ngClass]="
                        calculateParticipationColor(data?.participation)
                      "
                    ></em>
                  </div>
                  <div class="col ml-2 pb-0">
                    <app-read-only
                      readonlyText="{{ data?.participation }}"
                      toolTipMessage="{{ data?.participation }}"
                    ></app-read-only>
                  </div>
                </div>
              </div>
              <div class="col-3 w-13rem text-left sessionAttendeeColumn3">
                <app-label labelText="Pass/Fail"></app-label>
                <div
                  *ngIf="data?.passOrFail != ''"
                  class="grid pt-1 PassOrFail-status"
                >
                  <div class="col max-w-0 pb-0">
                    <em
                      class="pi pi-circle-fill ml-1 mr-1 mt-1"
                      [ngClass]="calculatePassOrFailColor(data?.passOrFail)"
                    ></em>
                  </div>
                  <div class="col ml-2 pb-0">
                    <div>
                      <app-read-only
                        readonlyText="{{ data?.passOrFail }}"
                        toolTipMessage="{{ data?.passOrFail }}"
                      ></app-read-only>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-4 w-13rem text-left sessionAttendeeColumn4">
                <app-label labelText="Complete Date"></app-label>
                <div
                  class="grid pt-1 "
                >
                  <div class="col ml-2 pb-0">
                    <div>
                      <app-read-only
                        readonlyText="{{ data?.completeDate | date: 'dd-MMM-yyyy'}}"
                        toolTipMessage="{{ data?.completeDate | date: 'dd-MMM-yyyy'}}"
                      ></app-read-only>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5 w-13rem text-left gradeInput" *ngIf="gradeDisplay()">
                <app-label labelText="Grade"></app-label>
                <div class="GradeContainer">
                <div class="field flex">
                  <bpt-numeric-input
                  [(ngModel)]="data.grade"
                  [allowNegative]="false"
                  id="grade"
                  [showButtons]="false"
                  [minValue]="0"
                  [maxValue]="100"
                  [step]="1"
                  class="gradeInput"
                  (numericInputKeyDown)="gradeDataChange($event)"
                  (numericInputKeyUp)="gradeDataChange($event)"
                  (valueChange)="gradeDataChange($event)"
                  [disabled]="getGradeDispaly(data?.participation)"
                  [allowKeyboardIncrement]="true"                
                  >
                  </bpt-numeric-input>
                  <div class="percentageIcon relative">
                    <i class="fas fa-percent fa-lg"></i>
                  </div>
                </div>
                </div>
              </div>
              <div class="col">
              <div class="quizIcon" [ngClass]="changeIconColor(data?.isQuizAnswerButtonVisible)">
                <i class="fas fa-chart-column fa-lg" (click)="openQuiz(data?.attendee, data?.isQuizAnswerButtonVisible, data?.sessionId)"
                ></i>
              </div>
            </div>
            </div>
          </ng-template>
        </app-panel-list>
      </div>
    </p-tabView>
  </div>
</div>
